module.exports = __webpack_public_path__ + "Flag-278.69425a8e49f97e99179e1e13ee111990.svg";